import React, { Component } from 'react'
import { Button, ModalHeader, ModalBody, ModalFooter, Form, FormGroup } from 'reactstrap'
import RichTextEditor from '../../components/RichTextEditor'
import Resource from '../../Resource'
import { closeModal } from '../../reducers/modals'

import '../../styles/PostContainer.css'

export default class PostContainer extends Component {
  constructor(props) {
    super(props)

    this.state = Object.assign(
      {
        title: '',
        body: '',
        recipientId: 'everyone',
        type: 'post',
      },
      props.post || {}
    )
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  onCancel = () => {
    this.props.dispatch(closeModal())
  }

  onFinish = async () => {
    const { json, response } = await this.props.onSave(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  onDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this news update?')) {
      return
    }
    const { json, response } = await this.props.onDelete(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  render() {
    const verb = this.props.post ? 'Edit' : 'Create a'
    const { error, title, body, recipientId } = this.state
    let valid = title && body

    const sortUsers = (users) => {
      let filteredUsers = users
      if (this.props.me.role === 2) {
        filteredUsers = users.filter((user) => user.trainerId === this.props.me.id)
      }
      return filteredUsers
    }
    return (
      <div className="PostModalContainer">
        <ModalHeader toggle={this.onCancel}>{verb} News Update</ModalHeader>
        <div className="row">
          <div className="col-md-12">
            <ModalBody>
              {error && <div className="alert alert-danger">{error}</div>}
              <Form>
                <Resource collection path={['users']} placeholder={[]}>
                  {(users) => (
                    <FormGroup>
                      <div className="row">
                        <div className="col-md-12">
                          <label>Deliver to:</label>
                          <select
                            className="form-control"
                            value={recipientId}
                            onChange={(e) => this.setState({ recipientId: e.target.value })}
                          >
                            <option value="everyone">Everyone</option>
                            {sortUsers(users).map((u) => (
                              <option
                                key={u.id}
                                value={u.id}
                              >{`${u.firstName} ${u.lastName} (${u.username})`}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </FormGroup>
                  )}
                </Resource>

                <label>Subject:</label>
                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        type="text"
                        id="title"
                        value={title}
                        placeholder="Post Title"
                        onChange={(e) => this.setState({ title: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <label>Message:</label>
                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <RichTextEditor
                        value={body}
                        onChange={(e) => this.setState({ body: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </ModalBody>
          </div>
        </div>
        <ModalFooter>
          {this.props.onDelete ? (
            <Button className="btn btn-danger" onClick={this.onDelete}>
              Delete
            </Button>
          ) : (
            <div style={{ color: 'gray' }}>
              When you add this news post, a push notification will be sent to EL-FIT participants.
            </div>
          )}
          <div style={{ flex: 1 }} />
          <Button className="btn btn-primary" onClick={this.onFinish} disabled={!valid}>
            Save
          </Button>
        </ModalFooter>
      </div>
    )
  }
}
